import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppConstants } from "@core/constants/app";
import {
    isMaintenanceModeActive,
    isMaintenanceResponse,
    redirectToMaintenancePage,
    setMaintenanceModeActive,
} from "@core/utils/maintenance-mode.util";

@Injectable({
    providedIn: "root",
})
export class MaintenanceModeService {
    constructor(
        private readonly router: Router,
        private readonly ngbModal: NgbModal,
    ) {}

    isActive(): boolean {
        return isMaintenanceModeActive();
    }

    isMaintenanceResponse(error: HttpErrorResponse): boolean {
        return isMaintenanceResponse(error);
    }

    activate(): void {
        if (!isMaintenanceModeActive()) {
            setMaintenanceModeActive();
        }

        this.ngbModal.dismissAll();

        if (window.location.pathname.startsWith(AppConstants.MAINTENANCE_PAGE)) {
            return;
        }

        if (this.router.url?.startsWith(AppConstants.MAINTENANCE_PAGE)) {
            return;
        }

        if (this.router.navigated) {
            void this.router.navigateByUrl(AppConstants.MAINTENANCE_PAGE);
            return;
        }

        redirectToMaintenancePage();
    }
}
